import {
  AnimationComponent,
  Box,
  Grid2,
  LockIcon,
  Show,
  Tab,
  Tabs,
  Typography,
} from "components";
import DashboardLayout from "layouts/DashboardLayout";
import React, { lazy } from "react";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { AccountType } from "utils/common";

// Lazy load all components
const CompliancePage = lazy(() => import("Pages/Compliance"));
const Lead = lazy(() => import("Pages/Lead"));
const Client = lazy(() => import("Pages/Client"));
const Family = lazy(() => import("Pages/Family"));

const CRMMenu = () => {
  const dispatch = useAppDispatch();

  const userData = useAppSelector((state) => state?.user?.userData);

  const userInfo = useAppSelector((state) => state?.user?.userData);

  const { tabValueOfCRM } = useAppSelector((state) => state?.app?.tab);

  const tabs = [
    {
      label: "Client",
      component: Client,
      canAccess: true,
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Lead",
      component: Lead,
      canAccess: userData?.grantAccess,
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Onboarding",
      component: CompliancePage,
      canAccess: userData?.grantAccess,
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Family",
      component: Family,
      canAccess: userData?.grantAccess,
      accountType: [AccountType.RA_RIA, AccountType.RIA],
    },
  ];

  const isOnboarding =
    tabs[tabValueOfCRM]?.label?.toLowerCase() === "onboarding";

  return (
    <DashboardLayout title="Dashboard" disablePadding={isOnboarding}>
      <Grid2 container spacing={isOnboarding ? 0 : 1}>
        <Grid2 size={12}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              px: isOnboarding ? 2 : 0,
              pt: isOnboarding ? 2 : 0,
            }}
          >
            <Tabs
              sx={{
                "& .MuiTabs-flexContainer": {
                  backgroundColor: "var(--white)",
                },
              }}
              onChange={(e, val) => {
                dispatch(TAB({ tabKey: "tabValueOfCRM", tabValue: val }));
              }}
              value={tabValueOfCRM}
            >
              {tabs
                ?.filter((tab) =>
                  tab?.accountType?.includes(userInfo?.accountType),
                )
                ?.map((tab, index) => (
                  <Tab
                    key={index}
                    disabled={!tab.canAccess}
                    label={
                      <Box display={"flex"} gap={1}>
                        <Typography>{tab.label}</Typography>
                        {!tab.canAccess && <LockIcon width={16} height={16} />}
                      </Box>
                    }
                    disableRipple
                  />
                ))}
            </Tabs>
          </Box>
        </Grid2>
        <Grid2 size={12}>
          {tabs.map((tab, index) => (
            <Show.When key={index} isTrue={tabValueOfCRM === index}>
              <AnimationComponent>
                {React.createElement(tab.component)}
              </AnimationComponent>
            </Show.When>
          ))}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default CRMMenu;
